import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Summary from '../Summary';
import SummaryTrials from '../SummaryTrials';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

// eslint-disable-next-line react/prefer-stateless-function
class SummaryContainer extends React.Component {
  render() {
    const { isTrial } = this.props;

    return <>{isTrial ? <SummaryTrials /> : <Summary />}</>;
  }
}

SummaryContainer.propTypes = {
  isTrial: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  isTrial: state.isTrial
});

export default connect(mapStateToProps)(SummaryContainer);
